var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.474 16.365C15.2153 17.3245 13.6825 17.8561 12.1 17.8819C6.94545 17.8819 4 11.991 4 11.991C4.91596 10.2841 6.18636 8.79271 7.726 7.61703M10.5536 6.27684C11.0605 6.1582 11.5794 6.09889 12.1 6.10012C17.2545 6.10012 20.2 11.991 20.2 11.991C19.753 12.8272 19.2199 13.6145 18.6095 14.34M13.6611 13.5521C13.4588 13.7692 13.215 13.9432 12.944 14.064C12.673 14.1847 12.3805 14.2496 12.0839 14.2549C11.7873 14.2601 11.4926 14.2055 11.2175 14.0944C10.9425 13.9833 10.6926 13.818 10.4828 13.6082C10.2731 13.3984 10.1077 13.1485 9.99658 12.8735C9.88548 12.5984 9.83091 12.3038 9.83615 12.0072C9.84138 11.7105 9.90631 11.418 10.027 11.147C10.1478 10.8761 10.3219 10.6322 10.5389 10.4299",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1499 4L20.3499 20.2",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/show_password_icon.f910c35c0425e1609b9f8b9e0e5114da.svg";
export { ForwardRef as ReactComponent };